module.exports = __webpack_public_path__ + "img/23.075da625.jpg";